import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/switchMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import type { ServiceDependencies } from '../../services/types.tsx';
import {
	type Action,
	FETCH_AVATARS,
	fetchAvatarsFailure,
	fetchAvatarsSuccess,
} from '../../state/actions.tsx';
import { getProjectId } from '../../state/selectors.tsx';
import type { State } from '../../state/types.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	action$: ActionsObservable<Action>,
	store: MiddlewareAPI<State>,
	deps: ServiceDependencies,
): ActionsObservable<Action> =>
	// @ts-expect-error - TS2741 - Property 'ofType' is missing in type 'Observable<FetchAvatarsSuccessAction | FetchAvatarsFailureAction>' but required in type 'ActionsObservable<Action>'.
	action$.ofType(FETCH_AVATARS).switchMap(() => {
		const state = store.getState();
		const projectId = getProjectId(state);

		return Observable.fromPromise(deps.avatarService.get(projectId))
			.map(fetchAvatarsSuccess)
			.catch(() => Observable.of(fetchAvatarsFailure()));
	});
